import 'react';
import {Box, Paper, TextField} from '@mui/material';
import {DEFAULT_P1_CONFIRM, resolveP1DisplayText, resolveP1EditableText} from '@/pages/components/tax-computation/taxComP1Text';

interface TaxMainP1FootnotesProps {
    note?: string | null;
    confirm?: string | null;
    fallbackNote?: string;
    fallbackConfirm?: string;
    defaultNote?: string;
    noteChange?: (note: string) => void;
    confirmChange?: (confirm: string) => void;
    onTextBlur?: () => void;
}

export function TaxMainP1Footnotes({
                                       note,
                                       confirm,
                                       fallbackNote,
                                       fallbackConfirm,
                                       defaultNote = '',
                                       noteChange,
                                       confirmChange,
                                       onTextBlur,
                                   }: TaxMainP1FootnotesProps) {
    const displayNote = (noteChange ? resolveP1EditableText : resolveP1DisplayText)(
        note, fallbackNote, defaultNote);
    const displayConfirm = (confirmChange ? resolveP1EditableText : resolveP1DisplayText)(
        confirm, fallbackConfirm, DEFAULT_P1_CONFIRM);

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
            <Paper sx={{p: 2}}>
                <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    value={displayNote}
                    onChange={(e) => noteChange?.(e.target.value)}
                    onBlur={() => onTextBlur?.()}
                    variant="outlined"
                    size="small"
                    InputProps={{readOnly: !noteChange}}
                    sx={{'& .MuiInputBase-input': {fontSize: '0.875rem', lineHeight: 1.5}}}
                />
            </Paper>

            <Paper sx={{p: 2}}>
                <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    value={displayConfirm}
                    onChange={(e) => confirmChange?.(e.target.value)}
                    onBlur={() => onTextBlur?.()}
                    variant="outlined"
                    size="small"
                    InputProps={{readOnly: !confirmChange}}
                    sx={{'& .MuiInputBase-input': {fontSize: '0.875rem', lineHeight: 1.5, whiteSpace: 'pre-wrap'}}}
                />
            </Paper>
        </Box>
    );
}
